<template>
    <form class="card">
        <h3>Транзакции водителя</h3>
        <div class="grid _free mtop" v-if="status == ''">
            <div class="inline">
                <div class="grid">
                    <div class="text-item finance" v-if="data.diff_begin">
                        <span>Сальдо на начало</span>
                        <p :class="{negative: parseFloat(data.diff_begin) < 0}">{{ data.diff_begin | finance }}</p>
                    </div>
                    <div class="text-item finance" v-if="data.income">
                        <span>Долг перед водителем</span>
                        <p>{{ data.income | finance }}</p>
                    </div>
                    <div class="text-item finance" v-if="data.outcome">
                        <span>Заплачено</span>
                        <p>{{ data.outcome | finance }}</p>
                    </div>
                    <div class="text-item finance" v-if="data.diff">
                        <span>Сальдо на конец</span>
                        <p :class="{negative: parseFloat(data.diff) < 0}">{{ data.diff | finance }}</p>
                    </div>
                </div>
                <div class="grid">
                    <div class="text-item short" v-if="data.transaction_count">
                        <span>Транзакций</span>
                        <p>{{ data.transaction_count }}</p>
                    </div>
                    <div class="text-item short" v-if="data.cancelled">
                        <span>Отменено</span>
                        <p>{{ data.cancelled }}</p>
                    </div>
                </div>
                <div class="grid">
                    <div class="form-item">
                        <label for="pay_sum">Сумма оплаты</label>
                        <input type="text" id="pay_sum" class="text-input" v-model="pay_sum">
                    </div>
                    <div class="button _free _accept form-item" :class="{disabled: pay_sum == ''}" @click="$emit('showPopup', {popup: 'confirm', text: pay_sum})">Оплатить</div>
                </div>
            </div>

            <Transactions type="user" :data="data" @updateData="updateData"></Transactions>
        </div>
    </form>
</template>

<script>
    import Transactions from '@/components/Transactions.vue'

    export default {
        props: ['status', 'data', 'pay_sum'],
        components: {
            Transactions
        },
        methods: {
            updateData (data) {
                this.$emit('updateData', data)
            }
        },
        created () {
            this.$emit('getData')
        }
    }
</script>